<template>
  <v-container fluid>
    <v-row v-if="pdfs && pdfs.length > 0">
      <v-col v-for="(pdf, j) in parsedPDFs" :key="`${j}-${pdf.url}`"
        cols="12" sm="6" xl="3" lg="4"
      >
        <AmtstafelCard :label="pdf.txt" :pdf="pdf.url" :main-color="mainColor" :chip="pdf.chip" :dark="dark" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

  import axios from 'axios'
  import { encode, escape } from 'base64-url'

  import AmtstafelCard from './AmtstafelCard.vue'

  export default {
    name: 'Amtstafel',
    props: ["startUrl", "mainColor", "dark"],
    components: {
      AmtstafelCard
    },
    computed: {
      parsedPDFs(){
        return this.pdfs.flat()
      }
    },
    methods: {
      async pdfsFromPage(url){
        const encodedUrl = escape(encode(url))
        const response = await axios({
          url: `https://graphql.sta.io/proxy/bsBi1mr1F/${encodedUrl}`
        })
        const dom = new DOMParser().parseFromString(response.data, "text/html")
        const pdfs = [...dom.querySelectorAll("li.filelink-item")].map(pdf => {
          const pdfUrl = new URL(pdf.querySelector("a").getAttribute('href'), url).toString()
          let txt = pdf.querySelector("span.filelink-filename") ? pdf.querySelector("span.filelink-filename").textContent : ''
          return { url: pdfUrl, txt }
        })
        return pdfs
      },
      load(){
        this.getPages()
      },
      async getPages(){
        this.pdfs = await this.pdfsFromPage(this.startUrl)
      }
    },
    mounted(){
      this.load()
      setInterval(() => {
        this.load()
      }, 1000*60*5)
    },
    watch: {
      startUrl(){
        this.load()
      }
    },
    data: () => ({
      dom: null,
      pdfs: null,
    }),
  }
</script>
